import { isPolyquantId } from './polyquant';
import { isMainFeed2Id, RU_FEED, TRANSFERS } from './feedContext';
import type { Fork } from './protocol';

/** С /app снимаем целиком. Русская лента и переливы не трогаем. */
export const FEED_HIDE_BOOKS: ReadonlySet<string> = new Set(['vbet']);

export function feedHidesBooks(): boolean {
  return !RU_FEED && !TRANSFERS;
}

export function hasHiddenBook(fork: Fork): boolean {
  for (const leg of fork.legs ?? []) {
    const code = String(leg.s ?? '').trim().toLowerCase();
    if (FEED_HIDE_BOOKS.has(code)) return true;
  }
  return false;
}

export function dropHiddenBooks(forks: Map<string, Fork>): Map<string, Fork> {
  if (!feedHidesBooks()) return forks;
  const next = new Map<string, Fork>();
  for (const [id, fork] of forks) {
    if (isPolyquantId(id) || isMainFeed2Id(id) || !hasHiddenBook(fork)) next.set(id, fork);
  }
  return next;
}
